
import setting from './setting';
export default {
    getList: ($axios,data)=>{
        return $axios.get(`${setting.http.base_url}/producto/maestros`,{headers:setting.http.headers()});
    },
}
